import { Action, createReducer, on } from '@ngrx/store';
import { ScanMode } from '../models';
import {
  closeScannerCameraAction,
  pauseScanningSuccessAction,
  restartScanningAction,
  resumeScanningSuccessAction,
  showScannerCameraAction,
  startScanningAction,
  startScanningSuccessAction,
  stopScanningSuccessAction,
} from './scanner.actions';
import { ScannerState } from './scanner.state';

const initialState = new ScannerState();

const reducer = createReducer(
  initialState,
  on(showScannerCameraAction, (state, payload) => {
    const newState = { ...state };
    newState.isContinuousScan = payload.scanMode === ScanMode.Continuous;
    newState.actionToDispatchOnBarcodeScanned = payload.actionToDispatchOnBarcodeScanned;
    newState.isScannerShown = true;
    return newState;
  }),
  on(closeScannerCameraAction, (state, payload) => {
    const newState = { ...state };
    newState.isScannerShown = false;
    newState.isTemporaryClosed = payload.isTemporaryClosed;
    return newState;
  }),
  on(restartScanningAction, (state) => {
    const newState = { ...state };
    newState.scannerShouldRestart = true;
    return newState;
  }),
  on(startScanningAction, (state) => {
    const newState = { ...state };
    newState.scannerShouldRestart = false;
    return newState;
  }),
  on(startScanningSuccessAction, (state) => {
    const newState = { ...state };
    newState.isScannerStarted = true;
    return newState;
  }),
  on(resumeScanningSuccessAction, (state) => {
    const newState = { ...state };
    newState.isScannerStarted = true;
    return newState;
  }),
  on(pauseScanningSuccessAction, (state) => {
    const newState = { ...state };
    newState.isScannerStarted = false;
    return newState;
  }),
  on(stopScanningSuccessAction, (state) => {
    const newState = { ...state };
    newState.isScannerStarted = false;
    return newState;
  })
);

export function scannerReducer(state: ScannerState | null, action: Action) {
  return reducer(state, action);
}
